import { Row, Col, Card } from "react-bootstrap";
import { ActivityChart } from "./ActivityChart";
import { CompletionChart } from "./CompletionChart";
import BookingChart from "./BookingChart";
import { getDriverActivityChartAnalytics } from "../../services/Networkcall";
import { useEffect, useState } from "react";
import {Loader} from "../common/Loader";
import { errorAlert } from "../../components/common/Alert";

export default function DriverCharts() {
    const [loading, setLoading] = useState(false);
    const [chartData, setChartData] = useState(null);

    const fetchChartData = async () => {
        setLoading(true);
        try {
            const res = await getDriverActivityChartAnalytics();
            if (res.success) {
                setChartData(res?.data || null);
            } else {
                errorAlert({ message: res?.message || "Failed to fetch chart data" });
            }
        } catch (err) {
           errorAlert({message: err?.response?.data?.message || err?.message ||  "Failed to fetch chart data" });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchChartData();
    }, []);

    return (
        <>
            <Loader show={loading} />

            <Row className="mt-3 g-3">
                <Col lg={4}>
                    <Card className="p-3">
                        <div className="d-flex justify-content-between">
                            <h6>Bookings by Driver</h6>
                            {/* <span className="text-primary">View All</span> */}
                        </div>
                        <BookingChart data={chartData?.driverBookingChart || null} />
                    </Card>
                </Col>

                <Col lg={4}>
                    <Card className="p-3">
                        <div className="d-flex justify-content-between">
                            <h6>Completion Rate by Driver</h6>
                            {/* <span className="text-primary">View All</span> */}
                        </div>
                        <CompletionChart data={chartData?.completionRateChart || null} />
                    </Card>
                </Col>

                <Col lg={4}>
                    <Card className="p-3">
                        <div className="d-flex justify-content-between">
                            <h6>Activity Trend (Bookings)</h6>
                            {/* <span className="text-primary">View All</span> */}
                        </div>
                        <ActivityChart data={chartData?.bookingsPerMonthChart || null} />
                    </Card>
                </Col>  
            </Row>
        </>
    );
}